import PropTypes from 'prop-types';

import styles from './Link.module.css';

export const Link = ({ onClick, text, margin = true }) => {
  return (
    <div className={(margin) ? styles.customLink : styles.customNoMarginLink} onClick={onClick}>{text}</div>
  )
}

Link.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}